// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ——— Patients index (Stitch Clinical Precision) ——— */
.patients-screen {
  box-sizing: border-box;
  padding: 24px;
  min-width: 0;
  max-width: 100%;
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.patients-heading {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  flex-wrap: wrap;
  padding-bottom: 20px;
  border-bottom: 1px solid #F1F5F9;
}

.patients-heading__left {
  display: flex;
  flex-direction: column;
  gap: 2px;
  min-width: 0;
}

.patients-heading__actions {
  display: flex;
  align-items: center;
  gap: 10px;
  flex-shrink: 0;
}

.patients-title-row {
  display: flex;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
}

.patients-title-row h1 {
  margin: 0;
  font-size: 24px;
  font-weight: 700;
  line-height: 1.2;
  letter-spacing: -0.02em;
  color: #0F172A;
}

.patients-count {
  display: inline-flex;
  align-items: center;
  padding: 2px 10px;
  border-radius: 9999px;
  border: 1px solid #E0F2FE;
  font-size: 12px;
  font-weight: 600;
  font-variant-numeric: tabular-nums;
  background: #E0F2FE;
  color: #0284C7;
}

.patients-subtitle {
  margin: 0;
  font-size: 12px;
  line-height: 16px;
  color: #64748B;
}

.patients-btn {
  box-sizing: border-box;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  height: 36px;
  padding: 0 14px;
  border-radius: 8px;
  font-size: 12px;
  font-weight: 600;
  font-family: inherit;
  cursor: pointer;
  white-space: nowrap;
  transition: background 0.12s ease, border-color 0.12s ease, color 0.12s ease;
}

.patients-btn--secondary {
  border: 1px solid #E2E8F0;
  background: #ffffff;
  color: #334155;
}

.patients-btn--secondary:hover {
  background: #F8FAFC;
}

.patients-btn--secondary .anticon {
  color: #64748B;
  font-size: 14px;
}

.patients-btn--primary {
  border: 1px solid #0EA5E9;
  background: #0EA5E9;
  color: #ffffff;
}

.patients-btn--primary:hover {
  background: #0284C7;
  border-color: #0284C7;
}

.patients-btn--primary .anticon {
  font-size: 14px;
}

.patients-btn:disabled {
  opacity: 0.55;
  cursor: not-allowed;
  pointer-events: none;
}

.patients-toolbar {
  display: flex;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
}

.patients-search {
  position: relative;
  display: flex;
  align-items: center;
  flex: 1 1 100%;
  min-width: 0;
  height: 38px;
  padding: 0 4px 0 12px;
  border: 1px solid #E2E8F0;
  border-radius: 8px;
  background: #ffffff;
  transition: border-color 0.12s ease, box-shadow 0.12s ease;
}

.patients-search:focus-within {
  border-color: #0EA5E9;
  box-shadow: 0 0 0 1px #0EA5E9;
}

.patients-search__icon {
  flex-shrink: 0;
  color: #94A3B8;
  font-size: 16px;
  margin-inline-end: 8px;
}

.patients-search__input.ant-input-affix-wrapper,
.patients-search__input.ant-input {
  flex: 1 1 auto;
  min-width: 0;
  height: 34px !important;
  padding: 0 !important;
  border: 0 !important;
  box-shadow: none !important;
  background: transparent !important;
  font-size: 12px;
}

.patients-search__input.ant-input-affix-wrapper .ant-input {
  font-size: 12px;
}

.patients-search__divider {
  width: 1px;
  height: 16px;
  margin: 0 8px;
  background: #E2E8F0;
  flex-shrink: 0;
}

.patients-search__by {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  height: 32px;
  padding: 0 10px;
  border: 0;
  border-radius: 6px;
  background: transparent;
  color: #475569;
  font-size: 12px;
  font-weight: 500;
  font-family: inherit;
  cursor: pointer;
  white-space: nowrap;
  flex-shrink: 0;
}

.patients-search__by:hover {
  background: #F8FAFC;
  color: #0F172A;
}

.patients-search__by-label {
  color: #94A3B8;
}

.patients-search__by-value {
  color: inherit;
}

.patients-search__by-caret {
  font-size: 10px;
  color: #64748B;
}

.patients-table-card {
  box-sizing: border-box;
  background: #ffffff;
  border: 1px solid #E2E8F0;
  border-radius: 12px;
  overflow: hidden;
  min-width: 0;
  max-width: 100%;
}

.patients-list {
  height: auto;
  min-height: 120px;
  min-width: 0;
}

.patients-table-scroll {
  width: 100%;
  overflow-x: auto;
  min-width: 0;
}

.patients-table {
  --patients-cols: 72px minmax(100px, 0.9fr) minmax(110px, 1fr) minmax(140px, 1.6fr) 100px minmax(130px, 1fr) 88px;
  display: grid;
  grid-template-columns: var(--patients-cols);
  width: 100%;
  min-width: 840px;
  font-size: 12px;
  background: #ffffff;
}

.patients-table.no-action {
  --patients-cols: 72px minmax(100px, 0.9fr) minmax(110px, 1fr) minmax(140px, 1.6fr) 100px minmax(130px, 1fr);
  min-width: 740px;
}

.patients-table.is-fetching {
  opacity: 0.72;
}

.patients-table__head,
.patients-table__row {
  display: grid;
  grid-template-columns: subgrid;
  grid-column: 1 / -1;
  align-items: stretch;
  margin: 0;
  padding: 0;
  border-radius: 0;
  box-sizing: border-box;
}

.patients-table__head {
  border-bottom: 1px solid #E2E8F0;
}

.patients-table__head .patients-cell {
  display: flex;
  align-items: center;
  min-height: 36px;
  padding: 8px 16px;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  color: #64748B;
  white-space: nowrap;
  background: #F8FAFC !important;
  border: 0 !important;
  border-radius: 0 !important;
}

.patients-table__row {
  cursor: pointer;
  border-bottom: 1px solid #F1F5F9;
}

.patients-table__row:last-child {
  border-bottom: 0;
}

.patients-table__row .patients-cell {
  display: flex;
  align-items: center;
  min-height: 40px;
  padding: 8px 16px;
  color: #334155;
  min-width: 0;
  background: #ffffff !important;
  border: 0 !important;
  border-radius: 0 !important;
  transition: background 0.12s ease;
}

.patients-table__row:hover .patients-cell {
  background: #F8FAFC !important;
}

.patients-cell.is-action {
  justify-content: flex-end;
  text-align: end;
}

[dir='rtl'] .patients-cell.is-action {
  justify-content: flex-start;
}

.patients-id,
.patients-mono {
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace;
  font-size: 12px;
  font-weight: 500;
  font-variant-numeric: tabular-nums;
  color: #64748B;
  line-height: 1.25;
}

.patients-mono.is-strong {
  color: #0F172A;
  font-weight: 500;
}

.patients-name {
  font-size: 13px;
  font-weight: 600;
  line-height: 1.25;
  color: #0F172A;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.patients-gender {
  display: inline-flex;
  align-items: center;
  height: 22px;
  padding: 0 8px;
  border-radius: 9999px;
  font-size: 11px;
  font-weight: 500;
  border: 1px solid transparent;
  white-space: nowrap;
}

.patients-gender.is-female {
  background: #FFF1F2;
  color: #BE123C;
  border-color: #FECDD3;
}

.patients-gender.is-male {
  background: #F1F5F9;
  color: #334155;
  border-color: #E2E8F0;
}

.patients-gender.is-neutral {
  background: #F8FAFC;
  color: #64748B;
  border-color: #E2E8F0;
}

.patients-row-link {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 0;
  border: 0;
  background: transparent;
  color: #0EA5E9;
  font-size: 12px;
  font-weight: 600;
  font-family: inherit;
  cursor: pointer;
  white-space: nowrap;
}

.patients-row-link:hover {
  color: #0284C7;
}

[dir='rtl'] .patients-row-link .anticon {
  transform: scaleX(-1);
}

.patients-empty {
  padding: 40px 24px;
  text-align: center;
  color: #94A3B8;
}

.patients-empty p {
  margin: 8px 0 0;
  font-size: 14px;
  font-weight: 500;
}

.patients-pager {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  flex-wrap: wrap;
  padding: 12px 16px;
  border-top: 1px solid #E2E8F0;
  background: #ffffff;
  font-size: 12px;
}

.patients-pager__meta {
  color: #64748B;
  font-variant-numeric: tabular-nums;
  font-weight: 500;
}

.patients-pager__controls {
  display: flex;
  align-items: center;
  gap: 8px;
}

.patients-pager__btn {
  box-sizing: border-box;
  height: 32px;
  padding: 0 12px;
  border-radius: 6px;
  border: 1px solid #E2E8F0;
  background: #ffffff;
  color: #334155;
  font-size: 12px;
  font-weight: 500;
  font-family: inherit;
  cursor: pointer;
}

.patients-pager__btn:hover:not(:disabled) {
  background: #F8FAFC;
}

.patients-pager__btn:disabled {
  opacity: 0.4;
  cursor: not-allowed;
}

.patients-pager__page {
  font-variant-numeric: tabular-nums;
  color: #475569;
  font-size: 12px;
  font-weight: 500;
  min-width: 72px;
  text-align: center;
}
`, "",{"version":3,"sources":["webpack://./src/pages/Patients/style.css"],"names":[],"mappings":"AAAA,uDAAuD;AACvD;EACE,sBAAsB;EACtB,aAAa;EACb,YAAY;EACZ,eAAe;EACf,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,eAAe;EACf,oBAAoB;EACpB,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,iBAAiB;EACjB,qBAAqB;EACrB,yBAAyB;EACzB,eAAe;EACf,gBAAgB;EAChB,kCAAkC;EAClC,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,sBAAsB;EACtB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,eAAe;EACf,mBAAmB;EACnB,4EAA4E;AAC9E;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,cAAc;EACd,YAAY;EACZ,YAAY;EACZ,qBAAqB;EACrB,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,0DAA0D;AAC5D;;AAEA;EACE,qBAAqB;EACrB,6BAA6B;AAC/B;;AAEA;EACE,cAAc;EACd,cAAc;EACd,eAAe;EACf,sBAAsB;AACxB;;AAEA;;EAEE,cAAc;EACd,YAAY;EACZ,uBAAuB;EACvB,qBAAqB;EACrB,oBAAoB;EACpB,2BAA2B;EAC3B,kCAAkC;EAClC,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,YAAY;EACZ,eAAe;EACf,SAAS;EACT,kBAAkB;EAClB,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,eAAe;EACf,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,sBAAsB;EACtB,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,iBAAiB;EACjB,YAAY;AACd;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,gHAAgH;EAChH,aAAa;EACb,2CAA2C;EAC3C,WAAW;EACX,gBAAgB;EAChB,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,2GAA2G;EAC3G,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf;;AAEA;;EAEE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,oBAAoB;EACpB,SAAS;EACT,UAAU;EACV,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,cAAc;EACd,mBAAmB;EACnB,8BAA8B;EAC9B,oBAAoB;EACpB,2BAA2B;AAC7B;;AAEA;EACE,eAAe;EACf,gCAAgC;AAClC;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;EACd,YAAY;EACZ,8BAA8B;EAC9B,oBAAoB;EACpB,2BAA2B;EAC3B,iCAAiC;AACnC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;;EAEE,6EAA6E;EAC7E,eAAe;EACf,gBAAgB;EAChB,kCAAkC;EAClC,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;EACd,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;EACZ,cAAc;EACd,qBAAqB;EACrB,eAAe;EACf,gBAAgB;EAChB,6BAA6B;EAC7B,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,UAAU;EACV,SAAS;EACT,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,eAAe;EACf,kBAAkB;EAClB,6BAA6B;EAC7B,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,kCAAkC;EAClC,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,sBAAsB;EACtB,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,kCAAkC;EAClC,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,kBAAkB;AACpB","sourcesContent":["/* ——— Patients index (Stitch Clinical Precision) ——— */\n.patients-screen {\n  box-sizing: border-box;\n  padding: 24px;\n  min-width: 0;\n  max-width: 100%;\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n}\n\n.patients-heading {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 16px;\n  flex-wrap: wrap;\n  padding-bottom: 20px;\n  border-bottom: 1px solid #F1F5F9;\n}\n\n.patients-heading__left {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n  min-width: 0;\n}\n\n.patients-heading__actions {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  flex-shrink: 0;\n}\n\n.patients-title-row {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  flex-wrap: wrap;\n}\n\n.patients-title-row h1 {\n  margin: 0;\n  font-size: 24px;\n  font-weight: 700;\n  line-height: 1.2;\n  letter-spacing: -0.02em;\n  color: #0F172A;\n}\n\n.patients-count {\n  display: inline-flex;\n  align-items: center;\n  padding: 2px 10px;\n  border-radius: 9999px;\n  border: 1px solid #E0F2FE;\n  font-size: 12px;\n  font-weight: 600;\n  font-variant-numeric: tabular-nums;\n  background: #E0F2FE;\n  color: #0284C7;\n}\n\n.patients-subtitle {\n  margin: 0;\n  font-size: 12px;\n  line-height: 16px;\n  color: #64748B;\n}\n\n.patients-btn {\n  box-sizing: border-box;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  height: 36px;\n  padding: 0 14px;\n  border-radius: 8px;\n  font-size: 12px;\n  font-weight: 600;\n  font-family: inherit;\n  cursor: pointer;\n  white-space: nowrap;\n  transition: background 0.12s ease, border-color 0.12s ease, color 0.12s ease;\n}\n\n.patients-btn--secondary {\n  border: 1px solid #E2E8F0;\n  background: #ffffff;\n  color: #334155;\n}\n\n.patients-btn--secondary:hover {\n  background: #F8FAFC;\n}\n\n.patients-btn--secondary .anticon {\n  color: #64748B;\n  font-size: 14px;\n}\n\n.patients-btn--primary {\n  border: 1px solid #0EA5E9;\n  background: #0EA5E9;\n  color: #ffffff;\n}\n\n.patients-btn--primary:hover {\n  background: #0284C7;\n  border-color: #0284C7;\n}\n\n.patients-btn--primary .anticon {\n  font-size: 14px;\n}\n\n.patients-btn:disabled {\n  opacity: 0.55;\n  cursor: not-allowed;\n  pointer-events: none;\n}\n\n.patients-toolbar {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  flex-wrap: wrap;\n}\n\n.patients-search {\n  position: relative;\n  display: flex;\n  align-items: center;\n  flex: 1 1 100%;\n  min-width: 0;\n  height: 38px;\n  padding: 0 4px 0 12px;\n  border: 1px solid #E2E8F0;\n  border-radius: 8px;\n  background: #ffffff;\n  transition: border-color 0.12s ease, box-shadow 0.12s ease;\n}\n\n.patients-search:focus-within {\n  border-color: #0EA5E9;\n  box-shadow: 0 0 0 1px #0EA5E9;\n}\n\n.patients-search__icon {\n  flex-shrink: 0;\n  color: #94A3B8;\n  font-size: 16px;\n  margin-inline-end: 8px;\n}\n\n.patients-search__input.ant-input-affix-wrapper,\n.patients-search__input.ant-input {\n  flex: 1 1 auto;\n  min-width: 0;\n  height: 34px !important;\n  padding: 0 !important;\n  border: 0 !important;\n  box-shadow: none !important;\n  background: transparent !important;\n  font-size: 12px;\n}\n\n.patients-search__input.ant-input-affix-wrapper .ant-input {\n  font-size: 12px;\n}\n\n.patients-search__divider {\n  width: 1px;\n  height: 16px;\n  margin: 0 8px;\n  background: #E2E8F0;\n  flex-shrink: 0;\n}\n\n.patients-search__by {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  height: 32px;\n  padding: 0 10px;\n  border: 0;\n  border-radius: 6px;\n  background: transparent;\n  color: #475569;\n  font-size: 12px;\n  font-weight: 500;\n  font-family: inherit;\n  cursor: pointer;\n  white-space: nowrap;\n  flex-shrink: 0;\n}\n\n.patients-search__by:hover {\n  background: #F8FAFC;\n  color: #0F172A;\n}\n\n.patients-search__by-label {\n  color: #94A3B8;\n}\n\n.patients-search__by-value {\n  color: inherit;\n}\n\n.patients-search__by-caret {\n  font-size: 10px;\n  color: #64748B;\n}\n\n.patients-table-card {\n  box-sizing: border-box;\n  background: #ffffff;\n  border: 1px solid #E2E8F0;\n  border-radius: 12px;\n  overflow: hidden;\n  min-width: 0;\n  max-width: 100%;\n}\n\n.patients-list {\n  height: auto;\n  min-height: 120px;\n  min-width: 0;\n}\n\n.patients-table-scroll {\n  width: 100%;\n  overflow-x: auto;\n  min-width: 0;\n}\n\n.patients-table {\n  --patients-cols: 72px minmax(100px, 0.9fr) minmax(110px, 1fr) minmax(140px, 1.6fr) 100px minmax(130px, 1fr) 88px;\n  display: grid;\n  grid-template-columns: var(--patients-cols);\n  width: 100%;\n  min-width: 840px;\n  font-size: 12px;\n  background: #ffffff;\n}\n\n.patients-table.no-action {\n  --patients-cols: 72px minmax(100px, 0.9fr) minmax(110px, 1fr) minmax(140px, 1.6fr) 100px minmax(130px, 1fr);\n  min-width: 740px;\n}\n\n.patients-table.is-fetching {\n  opacity: 0.72;\n}\n\n.patients-table__head,\n.patients-table__row {\n  display: grid;\n  grid-template-columns: subgrid;\n  grid-column: 1 / -1;\n  align-items: stretch;\n  margin: 0;\n  padding: 0;\n  border-radius: 0;\n  box-sizing: border-box;\n}\n\n.patients-table__head {\n  border-bottom: 1px solid #E2E8F0;\n}\n\n.patients-table__head .patients-cell {\n  display: flex;\n  align-items: center;\n  min-height: 36px;\n  padding: 8px 16px;\n  font-size: 11px;\n  font-weight: 700;\n  letter-spacing: 0.04em;\n  text-transform: uppercase;\n  color: #64748B;\n  white-space: nowrap;\n  background: #F8FAFC !important;\n  border: 0 !important;\n  border-radius: 0 !important;\n}\n\n.patients-table__row {\n  cursor: pointer;\n  border-bottom: 1px solid #F1F5F9;\n}\n\n.patients-table__row:last-child {\n  border-bottom: 0;\n}\n\n.patients-table__row .patients-cell {\n  display: flex;\n  align-items: center;\n  min-height: 40px;\n  padding: 8px 16px;\n  color: #334155;\n  min-width: 0;\n  background: #ffffff !important;\n  border: 0 !important;\n  border-radius: 0 !important;\n  transition: background 0.12s ease;\n}\n\n.patients-table__row:hover .patients-cell {\n  background: #F8FAFC !important;\n}\n\n.patients-cell.is-action {\n  justify-content: flex-end;\n  text-align: end;\n}\n\n[dir='rtl'] .patients-cell.is-action {\n  justify-content: flex-start;\n}\n\n.patients-id,\n.patients-mono {\n  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace;\n  font-size: 12px;\n  font-weight: 500;\n  font-variant-numeric: tabular-nums;\n  color: #64748B;\n  line-height: 1.25;\n}\n\n.patients-mono.is-strong {\n  color: #0F172A;\n  font-weight: 500;\n}\n\n.patients-name {\n  font-size: 13px;\n  font-weight: 600;\n  line-height: 1.25;\n  color: #0F172A;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.patients-gender {\n  display: inline-flex;\n  align-items: center;\n  height: 22px;\n  padding: 0 8px;\n  border-radius: 9999px;\n  font-size: 11px;\n  font-weight: 500;\n  border: 1px solid transparent;\n  white-space: nowrap;\n}\n\n.patients-gender.is-female {\n  background: #FFF1F2;\n  color: #BE123C;\n  border-color: #FECDD3;\n}\n\n.patients-gender.is-male {\n  background: #F1F5F9;\n  color: #334155;\n  border-color: #E2E8F0;\n}\n\n.patients-gender.is-neutral {\n  background: #F8FAFC;\n  color: #64748B;\n  border-color: #E2E8F0;\n}\n\n.patients-row-link {\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  padding: 0;\n  border: 0;\n  background: transparent;\n  color: #0EA5E9;\n  font-size: 12px;\n  font-weight: 600;\n  font-family: inherit;\n  cursor: pointer;\n  white-space: nowrap;\n}\n\n.patients-row-link:hover {\n  color: #0284C7;\n}\n\n[dir='rtl'] .patients-row-link .anticon {\n  transform: scaleX(-1);\n}\n\n.patients-empty {\n  padding: 40px 24px;\n  text-align: center;\n  color: #94A3B8;\n}\n\n.patients-empty p {\n  margin: 8px 0 0;\n  font-size: 14px;\n  font-weight: 500;\n}\n\n.patients-pager {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  flex-wrap: wrap;\n  padding: 12px 16px;\n  border-top: 1px solid #E2E8F0;\n  background: #ffffff;\n  font-size: 12px;\n}\n\n.patients-pager__meta {\n  color: #64748B;\n  font-variant-numeric: tabular-nums;\n  font-weight: 500;\n}\n\n.patients-pager__controls {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.patients-pager__btn {\n  box-sizing: border-box;\n  height: 32px;\n  padding: 0 12px;\n  border-radius: 6px;\n  border: 1px solid #E2E8F0;\n  background: #ffffff;\n  color: #334155;\n  font-size: 12px;\n  font-weight: 500;\n  font-family: inherit;\n  cursor: pointer;\n}\n\n.patients-pager__btn:hover:not(:disabled) {\n  background: #F8FAFC;\n}\n\n.patients-pager__btn:disabled {\n  opacity: 0.4;\n  cursor: not-allowed;\n}\n\n.patients-pager__page {\n  font-variant-numeric: tabular-nums;\n  color: #475569;\n  font-size: 12px;\n  font-weight: 500;\n  min-width: 72px;\n  text-align: center;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
